<script setup>
import { computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const store = useStore();
const { t } = useI18n();

const currentChat = useMapGetter('getSelectedChat');

const isAgentActive = computed(() =>
  currentChat.value?.labels?.includes('agente_ativo')
);

const toggle = async () => {
  const addLabel = isAgentActive.value ? 'agente_desativado' : 'agente_ativo';
  const removeLabel = isAgentActive.value ? 'agente_ativo' : 'agente_desativado';

  const currentLabels = currentChat.value?.labels || [];
  const newLabels = [
    ...currentLabels.filter(l => l !== removeLabel),
    addLabel,
  ];

  try {
    await store.dispatch('conversationLabels/update', {
      conversationId: props.conversationId,
      labels: newLabels,
    });
  } catch {
    useAlert(t('CONVERSATION.LABEL_TOGGLE_ERROR') || 'Erro ao alterar etiqueta');
  }
};
</script>

<template>
  <div
    class="flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer hover:bg-n-alpha-2"
    @click="toggle"
  >
    <span class="text-sm font-medium text-n-slate-12">
      {{ isAgentActive ? 'Agente Ativo' : 'Agente Desativado' }}
    </span>
    <div
      class="relative w-9 h-5 rounded-full transition-colors duration-200"
      :class="isAgentActive ? 'bg-n-brand' : 'bg-n-slate-6'"
    >
      <div
        class="absolute top-0.5 size-4 bg-white rounded-full shadow transition-transform duration-200"
        :class="isAgentActive ? 'translate-x-4' : 'translate-x-0.5'"
      />
    </div>
  </div>
</template>